import { useNavigate } from 'react-router-dom';
import React, { Fragment, useEffect, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import { Stripe } from '../Icons';

function classNames(...classes) {
	return classes.filter(Boolean).join(' ');
}

const ClientRow = ({ client, clients, setClients }) => {
	let navigate = useNavigate();

	const [name, setName] = useState(null);

	useEffect(() => {
		setName(client.client_id);
	}, [client]);

	function handleEditClick(id) {
		navigate('edit/' + id);
	}

	return (
		<>
			<tr key={client.id} className="even:bg-gray-50 hover:bg-indigo-50">
				<td
					onClick={() => {
						handleEditClick(client.id);
					}}
					className="cursor-pointer w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
					{name}
				</td>

				<td className="cursor-not-allowed hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
					<span>{client.currentActiveUsers}</span>
				</td>

				<td className="cursor-not-allowed hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
					{client.status === 0 && <span>Disabled&nbsp;</span>}
					{client.status === 1 && <span>Active&nbsp;</span>}
					{client.isClient === 1 && <span>Client</span>}
					{!client.isClient === 0 && <span>Non-client</span>}
				</td>
				<td className="cursor-not-allowed hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
					{client.hasSubscription === 1 && <Stripe size={24} />}
				</td>
				<td className="even:bg-white hover:even:bg-white hover:odd:bg-white odd:bg-gray-50">
					<Menu as="div" className="relative ml-3 inline-block text-left">
						<div>
							<Menu.Button className="-my-2 flex items-center rounded-full bg-white p-2 text-gray-400 hover:text-gray-600">
								<span className="sr-only">Open options</span>
								<EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
							</Menu.Button>
						</div>

						<Transition
							as={Fragment}
							enter="transition ease-out duration-100"
							enterFrom="transform opacity-0 scale-95"
							enterTo="transform opacity-100 scale-100"
							leave="transition ease-in duration-75"
							leaveFrom="transform opacity-100 scale-100"
							leaveTo="transform opacity-0 scale-95">
							<Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
								<div className="py-1">
									<Menu.Item>
										{({ active }) => (
											<button
												type="button"
												className={classNames(
													active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
													'flex w-full justify-between px-4 py-2 text-sm',
												)}>
												<span>Generate invoice</span>
											</button>
										)}
									</Menu.Item>
									<Menu.Item>
										{({ active }) => (
											<button
												type="button"
												className={classNames(
													active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
													'flex w-full justify-between px-4 py-2 text-sm',
												)}>
												<span>Create subscription</span>
											</button>
										)}
									</Menu.Item>
								</div>
							</Menu.Items>
						</Transition>
					</Menu>
				</td>
			</tr>
		</>
	);
};

export default ClientRow;
